import { Alert } from '@mui/material'
import { useContext, useEffect, useRef } from 'react'
import { HIDE_BANNER, SHOW_INFO_BANNER, SHOW_SUCCESS_BANNER, SHOW_WARNING_BANNER } from '../../store/reducer/NotificationBannerReducer'
import { AppContext } from '../../store/AppProvider'

const useTimeout = (callbackFunction = () => { }) => {
    const savedCallback = useRef(callbackFunction)
    useEffect(() => {
        savedCallback.current = callbackFunction
    }, [callbackFunction])

    useEffect(() => {
        const functionId = setTimeout(() => {
            savedCallback.current()
        }, 5000);
        return () => clearTimeout(functionId)
    }, [])
}

export const Notification = ({ bannerDetails }) => {
    const { setShowBanner } = useContext(AppContext)
    const { showBannerAlert, bannerId, bannerMessage, bannerType } = bannerDetails

    useTimeout(() => setShowBanner({ type: HIDE_BANNER, bannerId }))

    const getSeverity = (bannerType) => {
        if (bannerType === SHOW_SUCCESS_BANNER) return "success"
        else if (bannerType === SHOW_INFO_BANNER) return "info"
        else if (bannerType === SHOW_WARNING_BANNER) return 'warning'
        else return 'error'
    }

    return (
        <div style={{ marginTop: 10 }} >
            {Boolean(showBannerAlert) &&
                <Alert
                    variant='filled'
                    severity={getSeverity(bannerType)}
                    onClose={() => setShowBanner({ type: HIDE_BANNER, bannerId })}>
                    {bannerMessage}
                </Alert>}
        </div>
    )
}
